import React from 'react'
import { useRouter } from 'react-router5';
import { Button } from '@material-ui/core'
import Pilot from '../images/noun_pilot_879259.svg'
import './MainScreen.css'

export default function MainScreen({ nextQuizId }) {
  const router = useRouter()

  return (
    <div className="MainScreen">
      <h1 className="MainScreen__title">Pilota </h1>

      <div>
        <img className="MainScreen__logo" src={Pilot} />
      </div>

      <Button
        color="primary"
        className="MainScreen__startButton"
        style={{ fontSize: "1.5rem" }}
        onClick={() => router.navigate('quiz_picker')}
      >
        Start
      </Button>

      <Button color="primary"
        onClick={() => router.navigate('leaderboards')}
      >
        Leaderboards
      </Button>
      <Button color="primary"
        onClick={() => router.navigate('settings')}
      >
        Settings
      </Button>
      <Button color="primary">
        Profile
      </Button>
    </div>
  )
}
